// Mint-SalesToday (desktop 1536): logic thuần của màn "Hôm nay của Sale". Dữ liệu mẫu theo script board (IT0 / CONTACT / KIND).
// Không có tiền ở màn này (chỉ số việc, hạn, trạng thái).

export type TaskKind = 'SLD' | 'PRC' | 'QEX' | 'JOB' | 'CTR' | 'VOL' | 'IDL' | 'TSK';
export type TaskTone = 'ok' | 'warn' | 'err' | 'pri' | 'none';
/** -1 quá hạn · 0 hôm nay · 1 sắp tới */
export type TaskLevel = -1 | 0 | 1;
export type TaskAct = 'link' | 'ai' | 'call';

export interface SaleTask {
  sn: string;
  sale: string;
  kind: TaskKind;
  text: string;
  due: string;
  lvl: TaskLevel;
  act: string;
  href: string;
}

export const ME = 'DAVID';

export const KIND: Record<TaskKind, { label: string; tone: TaskTone }> = {
  SLD: { label: 'Follow phiếu', tone: 'pri' },
  PRC: { label: 'Pricing', tone: 'warn' },
  QEX: { label: 'Báo giá sắp hết hạn', tone: 'warn' },
  JOB: { label: 'Follow job', tone: 'pri' },
  CTR: { label: 'Hợp đồng', tone: 'err' },
  VOL: { label: 'Giảm sản lượng', tone: 'warn' },
  IDL: { label: 'Lâu chưa có job', tone: 'none' },
  TSK: { label: 'Việc tự thêm', tone: 'none' },
};

/** Bảy ô đếm trên cùng, theo thứ tự board. */
export const KPI: readonly { kind: TaskKind; label: string }[] = [
  { kind: 'SLD', label: 'Phiếu đến hạn follow' },
  { kind: 'PRC', label: 'Chờ / đã trả Pricing' },
  { kind: 'QEX', label: 'Báo giá sắp hết / giá đổi' },
  { kind: 'JOB', label: 'Follow job' },
  { kind: 'CTR', label: 'Hợp đồng cần xử lý' },
  { kind: 'VOL', label: 'Khách giảm sản lượng' },
  { kind: 'IDL', label: 'Khách lâu chưa có job' },
];

const PIPE = 'Mint-Pipeline';
const QUOTE = 'Mint-Quote';
const t = (sn: string, sale: string, kind: TaskKind, text: string, due: string, lvl: TaskLevel, act: string, href = ''): SaleTask => ({ sn, sale, kind, text, due, lvl, act, href });

export const TASKS: readonly SaleTask[] = [
  t('GREENBUD', 'DAVID', 'SLD', 'Follow SI-261022-K8QX · 2×40RF đi Yokohama', 'Hạn 24/Oct/2026 10:00', 1, 'Mở phiếu', PIPE),
  t('GREENBUD', 'DAVID', 'QEX', 'Q26FRSGNYOK198 hết hiệu lực 31/Oct/2026', 'Còn 7 ngày làm việc', 1, 'Gia hạn báo giá', QUOTE),
  t('GREENBUD', 'DAVID', 'JOB', 'SE260639198 · BK Confirmed · cut-off SI 23/Oct/2026 11:00', 'Nhắc khách gửi SI', 0, 'Mở job', 'Mint-JobDetail'),
  t('SAVITA', 'DAVID', 'SLD', 'Follow SI-261019-Z2HD · 40DC Busan + kéo cont', 'Quá hạn 1 ngày', -1, 'Mở phiếu', PIPE),
  t('SAVITA', 'DAVID', 'QEX', 'Q26FDSGNPUS199 · cước SINOKOR đổi, cần báo lại', 'Giá đổi từ 20/Oct/2026', 0, 'Cập nhật giá', QUOTE),
  t('VINAVARIETY', 'DAVID', 'SLD', 'Follow SI-261020-H5TR · RF Jeddah + C/O', 'Hạn 23/Oct/2026 10:00', 1, 'Mở phiếu', PIPE),
  t('VINAVARIETY', 'DAVID', 'CTR', 'Có job SE260639212 nhưng chưa có hợp đồng dịch vụ', 'Cần tạo hợp đồng', 0, 'Tạo hợp đồng', 'Mint-Contract'),
  t('RUITONGVN-SC', 'DAVID', 'PRC', 'PR-261022-101530-T2 chờ Pricing trả giá', 'Đã chờ 2 giờ làm việc', 0, 'Mở yêu cầu', QUOTE),
  t('TUELAMHCMC', 'DAVID', 'CTR', 'SCSGN202600067 chưa ký · khách giữ bản từ 21/Oct', 'Nhắc khách ký', 1, 'Mở hợp đồng', 'Mint-Contract'),
  t('TAMNGOC', 'DAVID', 'VOL', 'Job giảm: 6 → 3 job so với kỳ trước', 'Cần gọi hỏi thăm', 1, 'Gọi khách'),
  t('THACO', 'TUANNT', 'PRC', 'PR-261021-094620-K8 Pricing đã trả giá · báo lại khách', 'Trả lúc 21/Oct/2026 10:02', 0, 'Mở phiếu', PIPE),
  t('ARRIVE', 'TUANNT', 'IDL', 'Không có job mới', '31 ngày chưa có job', 1, 'Hana soạn mail'),
  t('COCOGROUP', 'ANDG', 'QEX', 'Q26FRSGNNSA201 hết hiệu lực 30/Oct/2026', 'Còn 6 ngày làm việc', 1, 'Gia hạn báo giá', QUOTE),
  t('EMDEES', 'ANDG', 'IDL', 'Không có job mới', '45 ngày chưa có job', 1, 'Hana soạn mail'),
  t('BAOANVISION', 'AnNPH', 'PRC', 'PR-261015-142210-Q3 Pricing bỏ qua · cần hỏi lại', 'Quá hạn follow 2 ngày', -1, 'Mở phiếu', PIPE),
];

export const CONTACT: Record<string, string> = {
  GREENBUD: 'Phạm Ngọc Thảo · Logistics', SAVITA: 'Ms Hương · Xuất nhập khẩu', VINAVARIETY: 'Mr Khoa · Mua hàng', 'RUITONGVN-SC': 'Ms Vy · Logistics',
  TUELAMHCMC: 'Anh Tuấn · Giám đốc', TAMNGOC: 'Chị Ngọc · Kế hoạch', THACO: 'Mr Bình · Logistics', ARRIVE: 'Ms Lan · XNK', COCOGROUP: 'Mr Dũng · Logistics',
  EMDEES: 'Mr Kim · Purchasing', BAOANVISION: 'Ms Hoa · XNK',
};

export const SALES: readonly { k: string; ab: string }[] = [
  { k: 'DAVID', ab: 'DV' }, { k: 'TUANNT', ab: 'TU' }, { k: 'ANDG', ab: 'AN' }, { k: 'AnNPH', ab: 'AP' },
];

export type Period = '7' | '30' | '90';
export type Scope = 'mine' | 'team';

export const taskKey = (x: SaleTask) => `${x.sn}|${x.text}`;
export const abbr = (x: string) => x.replace(/[^0-9A-Za-zÀ-ỹ]/g, '').slice(0, 2).toUpperCase();

/** Kỳ theo dõi: việc "lâu chưa có job" / "giảm sản lượng" phụ thuộc kỳ (như `perAdj` của board). */
export function inPeriod(x: SaleTask, per: Period): boolean {
  if (x.kind === 'IDL') {
    const n = Number(/^(\d+)/.exec(x.due)?.[1] ?? 0);
    return per === '7' ? n >= 7 : n >= 30;
  }
  if (x.kind === 'VOL') return per !== '7';
  return true;
}

export function visibleTasks(rows: readonly SaleTask[], per: Period): SaleTask[] {
  return rows.filter((x) => inPeriod(x, per));
}

export function inScope(rows: readonly SaleTask[], scope: Scope, saleSel: string | null): SaleTask[] {
  return rows.filter((x) => (scope === 'mine' ? x.sale === ME : !saleSel || x.sale === saleSel));
}

type Done = Readonly<Record<string, boolean>>;

export function kpiCount(rows: readonly SaleTask[], kind: TaskKind, done: Done) {
  const a = rows.filter((x) => x.kind === kind && !done[taskKey(x)]);
  return { n: a.length, overdue: rows.some((x) => x.kind === kind && x.lvl < 0 && !done[taskKey(x)]) };
}

export function pace(rows: readonly SaleTask[], done: Done) {
  const open = (l: TaskLevel) => rows.filter((x) => x.lvl === l && !done[taskKey(x)]).length;
  const nDn = rows.filter((x) => done[taskKey(x)]).length;
  const all = rows.length;
  return {
    segs: [
      { k: 'Quá hạn', n: open(-1), c: 'var(--err)' },
      { k: 'Hôm nay', n: open(0), c: 'var(--warn)' },
      { k: 'Sắp tới', n: open(1), c: 'var(--pri)' },
      { k: 'Đã xong', n: nDn, c: 'var(--ok-dot)' },
    ],
    sub: `${all - nDn} việc chưa xong · ${new Set(rows.map((x) => x.sn)).size} khách`,
    pct: all ? Math.round((nDn / all) * 100) : 0,
    done: nDn,
    all,
    /** 24 vạch tiến độ: số vạch bật */
    ticksOn: all ? Math.round((nDn / all) * 24) : 0,
  };
}

export interface TaskGroup { sn: string; sale: string; contact: string; overdue: number; open: number; rows: SaleTask[] }

/** Nhóm theo khách, khách có việc gấp nhất (lvl nhỏ nhất) lên trước — giữ thứ tự gốc khi bằng nhau. */
export function groupByCustomer(rows: readonly SaleTask[], done: Done, sort = true): TaskGroup[] {
  const by = new Map<string, SaleTask[]>();
  rows.forEach((x) => by.set(x.sn, [...(by.get(x.sn) ?? []), x]));
  return [...by.entries()]
    .sort(sort ? (a, b) => Math.min(...a[1].map((x) => x.lvl)) - Math.min(...b[1].map((x) => x.lvl)) : () => 0)
    .map(([sn, arr]) => ({
      sn,
      sale: arr[0]!.sale,
      contact: CONTACT[sn] ?? 'Liên hệ chính',
      overdue: arr.filter((x) => x.lvl < 0 && !done[taskKey(x)]).length,
      open: arr.filter((x) => !done[taskKey(x)]).length,
      rows: arr,
    }));
}

export function teamStats(all: readonly SaleTask[], done: Done) {
  const openOf = (k: string) => all.filter((x) => x.sale === k && !done[taskKey(x)]);
  const mx = Math.max(1, ...SALES.map((s) => openOf(s.k).length));
  return SALES.map((s) => {
    const a = openOf(s.k);
    const od = a.filter((x) => x.lvl < 0).length;
    return { ...s, open: a.length, od, customers: new Set(a.map((x) => x.sn)).size, segs: [od, a.length - od, mx - a.length] };
  });
}

/** Chữ hạn rút gọn (như `__dueS` của board). */
export function dueShort(due: string): string {
  let m: RegExpExecArray | null;
  if ((m = /^Hạn (\d{1,2}\/[A-Za-z]{3})\/\d{4}(.*)$/.exec(due))) return `${m[1]!}${m[2]!}`;
  if ((m = /^Hạn (.+)$/.exec(due))) return m[1]!;
  if ((m = /^Còn (\d+) ngày làm việc$/.exec(due))) return `${m[1]} ngày LV`;
  if ((m = /^Quá hạn (.+)$/.exec(due))) return m[1]!;
  if ((m = /^Đã chờ (\d+) giờ làm việc$/.exec(due))) return `${m[1]}h LV`;
  return due;
}
export type DueIcon = 'alarm' | 'clock' | 'warn' | null;
export const dueIcon = (due: string): DueIcon => (/^Hạn /.test(due) ? 'alarm' : /^Còn |^Đã chờ /.test(due) ? 'clock' : /^Quá hạn /.test(due) ? 'warn' : null);
export const actType = (x: SaleTask): TaskAct => (x.act === 'Hana soạn mail' ? 'ai' : x.href ? 'link' : 'call');

export type ActIcon = 'open' | 'refresh' | 'renew' | 'contract' | 'req' | 'call' | 'none';
export const actIcon = (act: string): ActIcon =>
  /^Mở (phiếu|job)$/.test(act) ? 'open' : act === 'Cập nhật giá' ? 'refresh' : act === 'Gia hạn báo giá' ? 'renew' : /hợp đồng/i.test(act) ? 'contract' : act === 'Mở yêu cầu' ? 'req' : act === 'Gọi khách' ? 'call' : 'none';
